import BaseInput from './BaseInput';
import CheckboxWidget from './CheckboxWidget';
import CheckboxesWidget from './CheckboxesWidget';
import ColorWidget from './ColorWidget';
import DateTimeWidget from './DateTimeWidget';
import DateWidget from './DateWidget';
import EmailWidget from './EmailWidget';
import FileWidget from './FileWidget';
import HiddenWidget from './HiddenWidget';
import RangeWidget from './RangeWidget';
import RadioWidget from './RadioWidget';
import SelectWidget from './SelectWidget';
import PasswordWidget from './PasswordWidget';
import TextareaWidget from './TextareaWidget';
import TextWidget from './TextWidget';
import UpDownWidget from './UpDownWidget';
import URLWidget from './URLWidget';

export default {
  BaseInput,
  CheckboxWidget,
  CheckboxesWidget,
  ColorWidget,
  DateTimeWidget,
  DateWidget,
  EmailWidget,
  FileWidget,
  HiddenWidget,
  RangeWidget,
  RadioWidget,
  SelectWidget,
  PasswordWidget,
  TextareaWidget,
  TextWidget,
  UpDownWidget,
  URLWidget,
};
